import { Pane } from "../Pane";
import { Div } from "../../Div";
import { ItemList } from "./ItemList";
import { SimpleItemList } from "./SimpleItemList";
import { toMap } from "../../../../../HA";

export class Section extends Pane {
    protected createItem(data: Map<any, any>) {
        const _d = data.get("d");
        switch (data.get("t")) {
            case "l":
                return new ItemList({d: _d});
            case "sl":
                return new SimpleItemList({d: _d});
            case "p":
                const t = new Div(_d);
                t.addClass("p");
                return t;
            case "t":
                const t2 = new Div(_d);
                t2.addClass("t2");
                return t2;
            default:
                return null;
        }
    }

    protected createSelf() {
        super.createSelf();
        this.addClass("sect");
        const tdata = this.get("d");
        if (tdata) {
            tdata.forEach((item: any) => {
                const child = this.createItem(toMap(item) as Map<any, any>);
                if (child) { this.appendChild(child); }
            });
        }
    }
}
